"use strict";

function FormImportController(FlashBag, appConfig) {
    var _this = this;
    this.api_server = appConfig.API_SERVER;

    this.import = function(e) {
        e.preventDefault();

        var data = new FormData();
        data.append("file", _this.file);

        this.importFunction({data: data}).then(function(response) {
            if (typeof _this.collapse !== "undefined")
                _this.collapse = false;

            _this.updateFunction();
        }, function(response) {
            FlashBag.apiError(response);
        });
        angular.element("input[type='file']").val(null);
    };
}

angular.module("core")
.component("formImport", {
    templateUrl: require("./form-import.component.html"),
    controller: FormImportController,
    bindings: {
        helperText: "<?",
        label: "<",
        sampleFileName: "@?",
        collapse: "=?",
        updateFunction: "=",
        importFunction: "&"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/form-import/form-import.component.js
// module id = 618
// module chunks = 0